import React from "react";
import { CpHeader, CpHeaderProps } from "../../cp-header/cp-header.component";

export type CardHeaderProps = CpHeaderProps;

export const CardHeader = ({ children, ...rest }: CardHeaderProps) => {
  return <CpHeader {...rest}>{children}</CpHeader>;
};
